import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import http from "../../util/http";
import "react-dates/initialize";
import ActiveUserResult from "./ActiveUserResult";
import { MuiThemeProvider } from "@material-ui/core/styles";
import aceTheme from "../../util/aceTheme";
const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
});

const displayTop = [100, 50, 25, 10];
class ActiveUsers extends Component {
  state = {
    top: 50,
    searching: true,
    activeUsers: [],
  };
  changeTop = (event) => {
    this.setState({ top: event.target.value });
  };
  activeUsersInterval = async () => {
    try {
      /*const activeUsers = await http.sendCommand("command:report:activeUsers", {
        top: this.state.top
      });*/
      this.setState({ searching: true });
      const activeUsers = await http.sendHelperCommand(
        "AciveUsersHelper.aspx",
        { top: this.state.top }
      );
      this.setState({
        reasonVoid: "Data Not Found",
        searching: false,
        activeUsers: activeUsers,
      });
    } catch (err) {
      this.setState({
        reasonVoid: err.message,
        searching: true,
        activeUsers: [],
      });
    }
  };
  componentDidMount = async () => {
    setInterval(this.activeUsersInterval, 5000);
  };
  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={aceTheme}>
        <div className={classes.container}>
          <form autoComplete="off">
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="top-players">Display Last</InputLabel>
              <Select
                native
                value={this.state.top}
                onChange={this.changeTop}
                inputProps={{
                  id: "top-players",
                }}
              >
                {displayTop.map((top) => (
                  <option value={top}>{top} Players</option>
                ))}
              </Select>
            </FormControl>
          </form>
          {this.state.searching && (
            <LinearProgress className={classes.progressLinear} />
          )}
          <ActiveUserResult
            {...{
              activeUsers: this.state.activeUsers,
              reasonVoid: this.state.reasonVoid,
            }}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

ActiveUsers.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ActiveUsers);
